import { ContractLineValidator } from '@/services/validation/ContractLineValidator';

import { validationSchema } from './validationSchema';
import { ContractLineBillingCycleOutput } from '@/graphql/contracts/_generated_/contracts';

export const validator = new ContractLineValidator<ContractLineBillingCycleOutput>(validationSchema);